import { useTranslation } from "react-i18next";

import { useCompany } from "@/query/hooks/useCompany";

export function useAiAssistantName(): string {
  const { t } = useTranslation();
  const { data: company } = useCompany();
  const configured = company?.ai_assistant_name?.trim();
  return configured || t("ai.fallbackName", "AI");
}
